import { useState } from 'react'
import { QuizContainer } from './components/QuizContainer'
import { trackQuizStart, trackButtonClick } from './utils/tracking/tracking'
import './App.css'

type QuizType = 'patient' | 'caregiver' | null

function App() {
  const [quizType, setQuizType] = useState<QuizType>(() => {
    // Check URL for explicit quiz type (/question/patient/27 or /question/caregiver/27)
    const pathMatch = window.location.pathname.match(/\/question\/(patient|caregiver)\/\d+/)
    if (pathMatch) {
      return pathMatch[1] as QuizType
    }

    // Try to load quiz type from localStorage on initial mount
    try {
      const stored = localStorage.getItem('quiz-session')
      if (stored) {
        const session = JSON.parse(stored)
        return session.quizType || null
      }
    } catch (e) {
      // Ignore parsing errors
    }
    return null
  })
  const [completed, setCompleted] = useState(false)

  if (completed) {
    return (
      <div className="completion-screen">
        <div className="completion-content">
          <h1>Thank you for taking the OncoDiary Quiz!</h1>
          <p>Your responses help us understand your needs and provide better support.</p>
          <button
            className="btn-primary"
            onClick={() => {
              trackButtonClick('take_quiz_again');
              setQuizType(null);
              setCompleted(false);
            }}
          >
            Take Quiz Again
          </button>
          <a href="/" className="btn-secondary">
            Back to Home
          </a>
        </div>
      </div>
    )
  }

  if (!quizType) {
    return (
      <div className="quiz-selection">
        <div className="selection-content-wrapper">
          <div className="selection-content">
            <h1>You don't have to do this alone</h1>
            <p>Cancer changes everything. It touches not just your body, but your mind, your spirit, your whole sense of who you are. This assessment is the first step toward healing—toward understanding what you're really going through, and finding your way back to yourself.</p>

            <div className="selection-buttons">
              <button
                className="btn-primary btn-large"
                onClick={() => {
                  trackButtonClick('quiz_type_patient');
                  trackQuizStart('patient');
                  setQuizType('patient');
                }}
              >
                I'm a Cancer Survivor
              </button>
              <button
                className="btn-primary btn-large"
                onClick={() => {
                  trackButtonClick('quiz_type_caregiver');
                  trackQuizStart('caregiver');
                  setQuizType('caregiver');
                }}
              >
                I'm a Caregiver
              </button>
            </div>
          </div>
        </div>

        <div className="medical-disclaimer">
          <p>This site does not offer medical advice. Always prioritize your health and safety, and consult a healthcare professional with any health concerns. This program is not evaluated by the FDA and is not intended to diagnose, treat, cure, or prevent any disease.</p>
        </div>
      </div>
    )
  }

  return (
    <QuizContainer
      quizType={quizType}
      onComplete={() => setCompleted(true)}
    />
  )
}

export default App
